import { AdditionalRegistrantDetails, PasscodeListMember } from '@/types/registration.types';

export enum REGISTERED_USER_ORDER_OPTIONS {
  UNORDERED = 0,
  NAME_ASC,
  NAME_DESC,
  EMAIL_ASC,
  EMAIL_DESC,
  LOCATION_ASC,
  LOCATION_DESC,
  DATE_ASC,
  DATE_DESC,
  ATTENDED_ASC,
  ATTENDED_DESC,
  COURSE_COMPLETION_ASC,
  COURSE_COMPLETION_DESC,
  REGISTRATION_STATUS_ASC,
  REGISTRATION_STATUS_DESC,
  LAST_LOGIN_ASC,
  LAST_LOGIN_DESC,
  STAR_SCORE_ASC,
  STAR_SCORE_DESC,
  WATCHTIME_ASC,
  WATCHTIME_DESC,
}

export type Sort = {
  sortBy:
    | 'name'
    | 'email'
    | 'locations'
    | 'created'
    | 'marked_attended_by_admin'
    | 'last_login'
    | 'reg_status'
    | 'course_completion'
    | 'watchtime'
    | 'star_score';
  sortOrder: 'asc' | 'desc';
};

export enum UpdateCompletedState {
  None,
  Updating,
  Passed,
  NotPassed,
  CertificateAvailable,
  GeneratingCertificate,
}

export enum PASSCODE_LIST_MEMBER_ORDER_OPTIONS {
  UNORDERED = 0,
  EMAIL_ASC,
  EMAIL_DESC,
  PASSCODE_ASC,
  PASSCODE_DESC,
  USES_ASC,
  USES_DESC,
  STATUS_ASC,
  STATUS_DESC,
  EVENTS_ASC,
  EVENTS_DESC,
  FIRST_NAME_ASC,
  FIRST_NAME_DESC,
  LAST_NAME_ASC,
  LAST_NAME_DESC,
  FULL_NAME_ASC,
  FULL_NAME_DESC,
  MAGIC_LINK_INVITE_SENT_ASC,
  MAGIC_LINK_INVITE_SENT_DESC,
  CREATED_ASC,
  CREATED_DESC,
  LAST_LOGIN_ASC,
  LAST_LOGIN_DESC,
}

export type PasscodeListMemberSort = {
  sortBy:
    | 'email'
    | 'passcode'
    | 'uses'
    | 'status'
    | 'events'
    | 'first_name'
    | 'last_name'
    | 'full_name'
    | 'magic_link_invite_sent'
    | 'created'
    | 'last_login';
  sortOrder: 'asc' | 'desc';
};

export enum PasscodeListMemberImportedProfileMap {
  first_name = 1,
  last_name = 2,
  email = 3,
}

export interface PasscodeListMemberProps {
  member: PasscodeListMember;
  type: number;
  passcodeListId: number;
  fromEventView: boolean;
  fromDetailsView: boolean;
  setDeletePasscodesModalOpen?: (isOpen: boolean) => void;
  mlDownload?: (member: PasscodeListMember) => Promise<void>;
}

export interface ListItemProps {
  member: PasscodeListMember;
  type: number;
  magicLink?: MagicLink;
}
export interface MagicLink {
  code: string;
  event_uuid: string;
  passcode_list_member: number;
  passcode_list: number;
  email: string;
  passcode: string | null;
  uses: number;
  created_date: string;
  modified_date: string | null;
  last_use: string | null;
  imported_profile: {
    first_name: string | null;
    last_name: string | null;
  } | null;
  first_name: string | null;
  last_name: string | null;
  event: string;
  magic_link: string;
  status: number;
  is_sent: boolean;
}

export enum MagicLinkStatus {
  deleted = 0,
  active,
  used,
}

export type RegistrantDetailMap = {
  [key: string]: AdditionalRegistrantDetails;
};

export enum REGISTRATION_STATUS_ENUM {
  ALL_REGISTRANTS = 'all',
  INVITED = 'invited',
  REGISTERED_AND_ATTENDED = 'attended',
  REGISTERED_NOT_ATTENDED = 'registered',
}

export const REGISTRATION_STATUS_LABELS: Record<REGISTRATION_STATUS_ENUM, string> = {
  [REGISTRATION_STATUS_ENUM.ALL_REGISTRANTS]: 'All registrants',
  [REGISTRATION_STATUS_ENUM.INVITED]: 'Invited',
  [REGISTRATION_STATUS_ENUM.REGISTERED_AND_ATTENDED]: 'Registered & attended',
  [REGISTRATION_STATUS_ENUM.REGISTERED_NOT_ATTENDED]: "Registered, didn't attended",
};
